export const enableRowSelection = ({ data }) => {
  return !!data;
};

export const enableHeaderSelection = ({ context: { rowsSelectable } }) =>
  !!rowsSelectable;
